export default "__VITE_ASSET__6643a840__"